import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FiTrash2, FiAlertTriangle } from "react-icons/fi";
import { showToast } from "../../../components/common/notification/Notification";

const PropertyDeleteModal = ({
  show,
  onHide,
  property,
  propertyService,
  onPropertyDeleted,
}) => {
  const [deleting, setDeleting] = useState(false);

  if (!show || !property) return null;

  const propertyTitle =
    property.project_name || property.property_name || property.title || `#${property.id}`;

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await propertyService.remove(property.id);
      showToast("Property deleted successfully", { type: "success" });
      if (onPropertyDeleted) onPropertyDeleted(property.id);
      onHide();
    } catch (err) {
      console.error("Error deleting property:", err);
      showToast("Failed to delete property", { type: "error" });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton>
        <div className="d-flex align-items-center gap-2">
          <FiAlertTriangle className="text-danger" size={20} />
          <Modal.Title style={{ fontSize: "16px", fontWeight: "700" }}>
            Delete Property
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body style={{ fontSize: "14px", color: "#475569" }}>
        Are you sure you want to delete this property listing (<strong>{propertyTitle}</strong>)? This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onHide}
          disabled={deleting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-danger d-inline-flex align-items-center gap-1"
          onClick={handleDelete}
          disabled={deleting}
        >
          <FiTrash2 size={14} />
          <span>{deleting ? "Deleting..." : "Delete"}</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PropertyDeleteModal;
